import { FunctionComponent, useEffect, useState } from 'react';

import { useAtom } from 'jotai';
import { BsEyeFill } from 'react-icons/bs';
import { FaSearchengin } from 'react-icons/fa';
import { GiClick, GiPayMoney, GiReceiveMoney } from 'react-icons/gi';
import { MdNotificationsActive } from 'react-icons/md';
import { TfiStatsUp } from 'react-icons/tfi';
import { TiMessages } from 'react-icons/ti';

import { GetDiscussionsByUser } from '@/api/fetch/marketplace-api';
import { LeadsCount } from '@/api/gen-protos/ads_pb';
import {
  DiscussionResponse,
  GetDiscussionsResponse,
  UserRequest,
} from '@/api/gen-protos/messenger_pb';
import {
  AuthTokenAtom,
  UserDataAtom,
} from '@/modules/core/store/grpc-free-store';
import { Itransaction } from '@/modules/core/types';
import Button from '@/tayara-kit/Button';
import { TkTayaraToken } from '@/tayara-kit/icons';
import Text from '@/tayara-kit/Text';

interface IAlert {
  title: string;
  searchParams: string[];
  viewResult: () => void;
  deleteAlert: () => void;
}
interface BigStatsProps {
  totalViews: number;
  totalLeads: number;
  weeklyViews: number[];
  weeklyLeads: number[];
  balance: number;
  transactionList: Itransaction[];
  alerts: IAlert[];
  Leads: LeadsCount | undefined;
}

const BigStats: React.FC<BigStatsProps> = ({
  totalViews,
  totalLeads,
  weeklyViews,
  weeklyLeads,
  alerts,
  balance,
  transactionList,
  Leads,
}) => {
  let viewsDifference: number = 0;
  let leadsDifference: number = 0;

  if (weeklyViews.length && weeklyLeads.length >= 2) {
    const weeklyViewsLastIndex = weeklyViews.length - 1;
    const weeklyViewsPrevIndex = weeklyViews.length - 2;
    const weeklyViewsLastValue: any = weeklyViews[weeklyViewsLastIndex];
    const weeklyViewsPrevValue: any = weeklyViews[weeklyViewsPrevIndex];
    viewsDifference =
      ((weeklyViewsLastValue - weeklyViewsPrevValue) / weeklyViewsLastValue) *
      100;

    const weeklyLeadsLastIndex = weeklyLeads.length - 1;
    const weeklyLeadsPrevIndex = weeklyLeads.length - 2;
    const weeklyLeadsLastValue: any = weeklyLeads[weeklyLeadsLastIndex];
    const weeklyLeadsPrevValue: any = weeklyLeads[weeklyLeadsPrevIndex];
    leadsDifference =
      ((weeklyLeadsLastValue - weeklyLeadsPrevValue) / weeklyLeadsLastValue) *
      100;
  }

  // const weeklyViewsSum = weeklyViews.reduce(
  //   (total, number) => total + number,
  //   0
  // );
  // const weeklyLeadsSum = weeklyLeads.reduce(
  //   (total, number) => total + number,
  //   0
  // );

  // const averageweeklyViews = (weeklyViewsSum / weeklyViews.length) * 100;
  // const averageweeklyLeads = (weeklyLeadsSum / weeklyViews.length) * 100;

  const BIG_STATS = [
    {
      id: 1,
      name: 'Clics',
      stat: totalViews,
      icon: GiClick,
      change: viewsDifference.toLocaleString(),
      changeType: viewsDifference,
      description: 'Personnes ont visité votre annonce',
      secondDescription: 'Statistiques des Clics des 30 derniers jours',
      weeks: weeklyViews,
    },
    {
      id: 2,
      name: 'Prospects',
      stat: totalLeads,
      icon: FaSearchengin,
      change: leadsDifference.toLocaleString(),
      changeType: leadsDifference,
      description: 'Personnes sont intéressées par votre annonce',
      secondDescription: 'Statistiques des Prospects des 30 derniers jours',
      weeks: weeklyLeads,
    },
  ];

  const targetDate = new Date();
  const filtredTransactions = transactionList
    ?.filter(
      (trc) =>
        trc && trc.description && trc.description.startsWith('Expire le:')
    )
    .filter((trc) => {
      if (trc && trc.description) {
        const description = trc.description
          .replace('Expire le:', '')
          .split('|')?.[0]
          ?.trim();
        const dateComponents = description?.split('-');
        if (dateComponents && dateComponents.length === 3) {
          const day = Number(dateComponents[0]);
          const month = Number(dateComponents[1]);
          const year = Number(dateComponents[2]);
          if (
            !Number.isNaN(day) &&
            !Number.isNaN(month) &&
            !Number.isNaN(year)
          ) {
            const expirationDate = new Date(year, month - 1, day);
            if (!Number.isNaN(expirationDate.getTime())) {
              if (expirationDate >= targetDate) {
                return trc;
              }
            }
          }
        }
      }
      return false;
    });

  // Calculate the current date and the date 30 days ago
  const currentDate = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(currentDate.getDate() - 30);

  // Filter transactions within the previous 30 days and where isVirement is false
  const filteredTransactions = transactionList?.filter((trc: any) => {
    const transactionDate = new Date(trc.createdTime);
    return (
      transactionDate >= thirtyDaysAgo &&
      transactionDate <= currentDate &&
      !trc.isVirement
    );
  });

  // Calculate the sum of amounts in the filtered transactions
  const sumOfAmounts = filteredTransactions?.reduce(
    (sum, trc) => sum + Number(trc.amount),
    0
  );

  // Calculate the balance by subtracting the sum of amounts from the initial balance
  const depence = sumOfAmounts;

  const [, setHaseMore] = useState(true);
  const [count, setCount] = useState(0);
  // @ts-ignore
  const [userData] = useAtom(UserDataAtom);

  const [authToken] = useAtom(AuthTokenAtom);
  const [discussions, setDiscussions] = useState<DiscussionResponse[]>([]);

  function secondsToTimeString(seconds: number) {
    return new Date(seconds * 1000).toLocaleDateString();
  }

  const GetDiscussions = async (init: boolean) => {
    if (userData?.kcid) {
      const userRequest = new UserRequest();
      userRequest.setKcid(userData?.kcid);
      userRequest.setSkip(init ? 0 : discussions?.slice(0, 2).length);
      userRequest.setLimit(2);
      GetDiscussionsByUser(authToken, userRequest).then(
        async (res: GetDiscussionsResponse) => {
          if (res && res.getDiscussionsList().length > 0) {
            setCount(res.getCountdisscussion());
            await setDiscussions((prevDiscussions) => [
              ...(prevDiscussions as DiscussionResponse[]),
              ...res.getDiscussionsList(),
            ]);
          } else {
            setHaseMore(false);
          }
        }
      );
    }
  };
  useEffect(() => {
    GetDiscussions(true).then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.kcid]);

  interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    state: boolean;
  }

  const Badge: FunctionComponent<BadgeProps> = ({
    state,
    children,
    ...props
  }) => (
    <span
      {...props}
      className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5
    ${state ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
    >
      {children}
    </span>
  );

  return (
    <>
      <div className="flex flex-wrap md:flex-nowrap gap-5 items-center">
        {BIG_STATS.map((item) => (
          <div
            key={item.id}
            className="flex grow flex-col my-2 md:my-0 mr-auto"
          >
            <div
              key={item.id}
              className="flex flex-wrap gap-5 justify-normal py-6 px-3 rounded-lg  shadow-lg shadow-green-50/80 overflow-hidden"
            >
              <div className="flex w-min grow">
                <div className=" bg-green-50 rounded-xl text-green-500 p-5 ">
                  <item.icon className="h-20 w-20" aria-hidden="true" />
                </div>
                <div className="w-1/2 flex flex-col px-4">
                  <p className="text-start text-xl font-extrabold text-neutral-500">
                    {item.name}
                  </p>
                  <p className="text-start text-4xl font-extrabold text-neutral-500">
                    {item.stat}
                  </p>
                  {/* <p
                className={`${item.changeType > 0
                  ? 'text-green-600'
                  : 'text-red-600'
                }
                flex items-baseline text-lg font-semibold`}
                >
                <span className="mr-1">
                {item.changeType > 0
                  ? 'Augmenté de '
                  : 'Baisse de  '}
                  
                  </span>
                  
                  {item.change} %
                  
                  
                  {item.changeType > 0 ? (
                    <HiArrowSmUp
                    className="self-center flex-shrink-0 h-5 w-5 text-green-500"
                    aria-hidden="true"
                    />
                    ) : (
                      <HiArrowSmDown
                      className="self-center flex-shrink-0 h-5 w-5 text-red-500"
                      aria-hidden="true"
                      />
                      )}
                      
                      
                    </p> */}
                  <div className="text-start text-xs text-neutral-400">
                    {item.description}
                  </div>
                </div>
              </div>

              <div className="w-fit grow flex flex-col justify-end ml-4 mr-4 mt-1 mb-1 xl:mb-0 gap-y-3 rounded-md">
                <div className="flex justify-center items-center gap-4">
                  <TfiStatsUp size={20} className="text-green-600" />
                  <p className="mt-2 self-start text-xs md:text-sm text-neutral-400 font-bold truncate">
                    {item.secondDescription}
                  </p>
                </div>
                {item.name === 'Prospects' && (
                  <ul className="flex justify-evenly mr-0 flex-row gap-4 md:gap-4 lg:gap-4 xl:gap-12">
                    <li
                      key={1}
                      className="flex flex-col justify-between items-start text-xs text-neutral-700"
                    >
                      {' '}
                      {`Chat ${Leads?.getChatleads()}` || 0}
                    </li>
                    <li
                      key={2}
                      className="flex flex-col justify-between items-start text-xs text-neutral-700"
                    >
                      {' '}
                      {`WhatsApp ${Leads?.getWhatsappleads()}` || 0}{' '}
                    </li>
                    <li
                      key={3}
                      className="flex flex-col justify-between items-start text-xs text-neutral-700 "
                    >
                      {`Numéro Teléphone ${Leads?.getShowphoneleads()}` || 0}
                    </li>
                    <li
                      key={4}
                      className="flex flex-col justify-between items-start text-xs text-neutral-700 "
                    >
                      {`Formulaire de contact ${Leads?.getContactformleads()}` ||
                        0}
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="w-full flex flex-col flex-wrap justify-center">
        <div className="w-full flex flex-wrap sm:flex-nowrap md:flex-nowrap lg:flex-wrap xl:flex-nowrap mt-4 px-0 sm:px-28 md:px-8  items-start  rounded-lg">
          <div className="w-full py-4 gap-10 md:gap-0 xl:gap-0 flex flex-wrap  md:flex-wrap lg:flex-nowrap xl:flex-nowrap">
            <div className="w-full rounded-lg shadow-sm shadow-slate-300 p-2 m-2 justify-start grow flex flex-col  text-neutral-500 ">
              <div className="">
                <div className="w-full flex justify-center text-lg font-extrabold text-neutral-500 mb-2">
                  <Text text="Solde des Jetons" />
                </div>
                <div
                  className={`w-full justify-center flex flex-wrap gap-y-3 items-center mt-4 mx-auto stat-value text gap-x-4 text-3xl font-extrabold text-neutral-500`}
                >
                  <GiReceiveMoney size={40} className="text-green-500" />
                  {balance}
                  <TkTayaraToken
                    size={20}
                    className="hidden sm:hidden md:hidden xl:block text-xl font-extrabold text-neutral-500 mt-2 mr-2"
                  />
                </div>
              </div>
              <Text
                className="w-full justify-self-center truncate my-4 text-center  text-neutral-500 font-light leading-tight text-sm"
                text="Votre solde total de jetons"
              />
            </div>
            <div className="w-full rounded-lg shadow-sm shadow-slate-300 p-2 m-2 justify-start grow flex flex-col   text-neutral-500 ">
              <div className="">
                <div className="w-full flex justify-center text-lg font-extrabold text-neutral-500 mb-2">
                  <Text text="Mes dépenses" />
                </div>
                <div
                  className={`w-full justify-center flex flex-wrap gap-y-3 items-center mt-4 mx-auto stat-value text gap-x-4 text-3xl font-extrabold text-neutral-500`}
                >
                  <GiPayMoney size={40} className="text-red-500" />
                  {depence}
                  <TkTayaraToken
                    size={20}
                    className="hidden sm:hidden md:hidden xl:block text-xl font-extrabold text-neutral-500 mt-2 mr-2"
                  />
                </div>
              </div>
              <Text
                className=" w-full justify-self-center truncate my-4 text-center  text-neutral-500 font-light leading-tight text-sm"
                text="Votre solde total de dépenses "
              />
            </div>
          </div>
          <div className="w-full py-4 gap-10 md:gap-0 xl:gap-0 flex flex-wrap  md:flex-wrap lg:flex-nowrap xl:flex-nowrap">
            <div className="w-full rounded-lg shadow-sm shadow-slate-300 p-2 m-2  justify-start grow  flex flex-col   text-neutral-500  ">
              <div className="">
                <div className="w-full flex justify-center text-lg font-extrabold text-neutral-500 mb-2">
                  <Text text="Mes messages" />
                </div>
                <div
                  className={`w-full justify-center flex flex-wrap gap-y-3 items-center mt-4 mx-auto stat-value text gap-x-4 text-3xl font-extrabold text-neutral-500`}
                >
                  <TiMessages
                    size={40}
                    className="text-xl font-extrabold text-neutral-500"
                  />

                  {count}
                </div>
              </div>
              <Text
                className=" justify-self-center truncate my-4  mx-auto w-fit text-center  text-neutral-500 font-light leading-tight text-sm"
                text="Total des messages reçus"
              />
            </div>
            <div className="w-full rounded-lg shadow-sm shadow-slate-300 p-2 m-2 justify-start grow flex flex-col   text-neutral-500   ">
              <div className="">
                <div className="w-full flex justify-center text-lg font-extrabold text-neutral-500 mb-2">
                  <Text text="Mes alertes" />
                </div>
                <div
                  className={`w-full justify-center flex flex-wrap gap-y-3 items-center mt-4 mx-auto stat-value text gap-x-4 text-3xl font-extrabold text-neutral-500`}
                >
                  <MdNotificationsActive
                    size={40}
                    className="text-xl font-extrabold text-neutral-500"
                  />
                  {alerts.length}
                </div>
              </div>
              <Text
                className=" justify-self-center truncate my-4  mx-auto w-fit text-center  text-neutral-500 font-light leading-tight text-sm"
                text="Total des recherches sauvegardées"
              />
            </div>
          </div>
        </div>
        <div className="w-full flex flex-wrap xl:flex-nowrap my-2 gap-4  justify-center items-center">
          <div className="w-full p-4 justify-evenly  grow stats flex flex-col  text-neutral-500 rounded-xl shadow-sm shadow-neutral-300 ">
            <div className="">
              <div className="flex flex-col sm:flex-row flex-wrap justify-between items-stretch sm:items-center truncate text-lg font-extrabold text-neutral-500 mb-2">
                <Text text="Expiration des Jetons" />
                <a
                  className="self-end sm:self-auto"
                  href="https://www.tayara.tn/profile/?t=transactions"
                  target={'_blank'}
                >
                  <Button
                    aria-label="Voir mes transactions"
                    className={`
                  
            self-end btn-sm text-info hover:bg-transparent hover:text-blue-700 !pl-0 md:pl-0 mt-4 sm:mt-1`}
                    icon={<BsEyeFill size={24} />}
                  >
                    Voir mes transactions
                  </Button>
                </a>
              </div>
              <div className="w-full overflow-x-hidden mt-6 mr-0 lg:mr-10 border-b-[1px] border-gray-300 stat-value flex items-center text gap-x-2 text-xl font-extrabold text-neutral-500">
                <div
                  className={`w-full ${
                    filtredTransactions.length >= 2 ? 'h-[4rem]' : 'h-[3rem]'
                  } overflow-x-hidden overflow-y-visible`}
                >
                  <table className="w-full">
                    {filtredTransactions.length > 0 ? (
                      <tbody>
                        {filtredTransactions.map((trc) => (
                          <tr
                            key={JSON.stringify(trc)}
                            className="flex items-center gap-x-2 hover:bg-neutral-100"
                          >
                            <td
                              className="flex gap-2 items-center "
                              tabIndex={0}
                            >
                              <TkTayaraToken className="text-info" size={20} />
                              <Badge state={trc.isVirement || true}>
                                {trc.amount}
                              </Badge>
                            </td>
                            <td tabIndex={0}>
                              <div className="text-xs lg:text-sm font-semibold">
                                {trc.description}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr className="flex justify-center items-center gap-x-2">
                          <td tabIndex={0}>
                            <div className="font-semibold text-base text-neutral-300">
                              Aucun jeton n&apos;a été trouvé
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
            <div className="flex items-center mt-4 align-middle">
              <Text
                className=" justify-self-center mr-auto w-fit  text-neutral-500 font-light  text-sm mt-2"
                text="Récapitulatif des dates d'expiration de vos jetons"
              />
              {/* <div className="flex items-center self-end">
                  <DownloadReceipts transactionList={transactionList} />

              </div> */}
            </div>
          </div>

          <div className="w-full p-4 justify-evenly  grow stats flex flex-col max-h-max  text-neutral-500 rounded-xl shadow-sm shadow-neutral-300 ">
            <div className="">
              <div className="flex flex-col sm:flex-row flex-wrap justify-between items-stretch sm:items-center truncate text-lg font-extrabold text-neutral-500 mb-2">
                <Text text="Messages récents" />
                <a
                  className="self-end sm:self-auto"
                  href="https://www.tayara.tn/chat"
                  target={'_blank'}
                >
                  <Button
                    aria-label="Voir mes messages"
                    className={`
                  
            self-end btn-sm text-info hover:bg-transparent hover:text-blue-700 !pl-0 md:pl-0 mt-4 sm:mt-1`}
                    icon={<BsEyeFill size={24} />}
                  >
                    Voir mes messages
                  </Button>
                </a>
              </div>
              <div className="w-full overflow-x-hidden mt-6 mr-0 lg:mr-10 border-b-[1px] border-gray-300 stat-value flex items-center text gap-x-2 text-xl font-extrabold text-neutral-500">
                <div
                  className={`w-full ${
                    discussions.length >= 2 ? 'h-[4.5rem]' : 'h-[4rem]'
                  } overflow-x-hidden overflow-y-visible`}
                >
                  <table className="w-full">
                    <tbody>
                      <tr className="flex items-center justify-center gap-x-2">
                        <td className="w-full" tabIndex={0}>
                          <div className="text-xs lg:text-sm font-semibold">
                            <ul>
                              {discussions.length > 0 ? (
                                <li>
                                  {discussions?.slice(0, 2).map((key) => {
                                    const adPicture =
                                      key
                                        .getDiscussion()
                                        ?.getAd()
                                        ?.getPicture() || '';
                                    return (
                                      <>
                                        <a
                                          key={key.getId()}
                                          className={`flex items-center hover:bg-neutral-100 px-4`}
                                        >
                                          <img
                                            className="object-cover w-10 h-10 rounded-full"
                                            src={
                                              adPicture?.includes('http')
                                                ? `https://www.tayara.tn/mediaGateway/resize-image?img=${adPicture.substring(
                                                    adPicture.lastIndexOf('/') -
                                                      2
                                                  )}&w=300`
                                                : `https://www.tayara.tn/mediaGateway/resize-image?img=${adPicture}&w=300`
                                            }
                                            alt={`ad's image of ${key
                                              .getDiscussion()
                                              ?.getAd()
                                              ?.getTitle()} on tayara`}
                                          />
                                          <div className="w-full pb-2">
                                            <div className="flex justify-between">
                                              <span className="block ml-2 font-semibold text-gray-600">
                                                {key
                                                  .getDiscussion()
                                                  ?.getAd()
                                                  ?.getTitle()}
                                              </span>
                                              <span className="block leading-tight ml-2 mt-2 text-sm text-gray-600">
                                                {secondsToTimeString(
                                                  Number(
                                                    key.toObject()?.discussion
                                                      ?.lastmessagedate?.seconds
                                                  )
                                                )}
                                              </span>
                                            </div>
                                            <span className="block leading-tight ml-2 text-sm font-normal text-gray-600">
                                              {
                                                key.toObject().discussion
                                                  ?.membersList[0]?.fullname
                                              }
                                              {' : '}
                                              {key
                                                .getDiscussion()
                                                ?.getLastmessagepreview()}
                                            </span>
                                          </div>
                                        </a>
                                      </>
                                    );
                                  })}
                                </li>
                              ) : (
                                <li className="font-semibold text-base text-neutral-300">
                                  Aucun message n&apos;a été reçu
                                </li>
                              )}
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap items-center  mt-4">
              <Text
                className=" justify-self-center mr-auto w-fit  text-neutral-500 font-light  text-sm "
                text="Récapitulatif des messages reçus récemment"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BigStats;
